import styled from "styled-components";

export const PlayerWrapper = styled.div`
  border-radius: 10px;
`;
export const PlayerMain = styled.div`
  overflow: scroll;
  position: relative;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0px;
  top: 0px;
  left: 0px;
  right: 0px;

  z-index: 1;
`;

export const PlayerFrame = styled.iframe`
  height: 824px;
  width: 824px;
  z-index: 2;

  @media (max-width: 820px) {
    height: 81vh !important;
    width: 100% !important;
  }
`;

export const DetailFooter = styled.div`
  height: 150px;
  width: 100%;
  background-color: whitesmoke;
`;
